import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/assets')({
    component: Outlet,
    staticData: {
        crumb: {
            label: 'Assets',
        },
    },
})
